<div class=" flex flex-col items-center justify-center">
	@if(loaderData().isLoading && !loaderData()?.showTimeCountDown){
		<div id="lottie-container" style="width: 100%; height: 150px;"></div>
	}

	@if(!loaderData().isLoading && loaderData().hasError) {
		<div class="mb-4">
			<svg width="60" height="60" viewBox="0 0 60 60" fill="none"
					 xmlns="http://www.w3.org/2000/svg">
				<rect opacity="0.1" width="60" height="60" rx="30" fill="#DC2626"></rect>
				<path
					d="M30 27.2498V29.9998V27.2498ZM30 35.4999H30.0134H30ZM20.6914 41H39.3086C41.3778 41 42.6704 38.7078 41.6358 36.8749L32.3272 20.3747C31.2926 18.5418 28.7074 18.5418 27.6728 20.3747L18.3642 36.8749C17.3296 38.7078 18.6222 41 20.6914 41Z"
					stroke="#DC2626" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"></path>
			</svg>
		</div>
	}

  @if (loaderData()?.showTimeCountDown && !loaderData().hasError) {
    <div class="flex flex-1 items-center relative">

      <div class="relative w-20 h-20">
        <svg class="w-full h-full" viewBox="0 0 100 100">
          <!-- Background circle -->
          <circle
            class="text-gray-200 stroke-current"
            stroke-width="10"
            cx="50"
            cy="50"
            r="40"
            fill="transparent"
          ></circle>
          <!-- Progress circle -->
          <circle
            class="text-blue-500 progress-ring__circle stroke-current"
            stroke-width="10"
            stroke-linecap="round"
            cx="50"
            cy="50"
            r="40"
            fill="transparent"
            stroke-dasharray="251.2"
            id="progress-circle"
          ></circle>
        </svg>
      </div>

      <div class="absolute info-wrapper">
        <div>
            <div class="value-wrapper">
              {{ loaderData().countDownSeconds }}
            </div>
        </div>
      </div>
    </div>
  }

	<div class="w-full flex justify-center">
		<span class="text-muted text-sm">{{loaderData().loaderMessage}}</span>
	</div>

	@if(!loaderData().isLoading && loaderData().hasError){
		<mat-dialog-actions class="mt-3" [align]="'center'">
			<button mat-stroked-button color="warn" class="custom-dialog-cancel" (click)="onClose()">Close</button>
			@if(loaderData().hasError && loaderData().retryFunction){
				<button mat-raised-button color="primary" class="custom-dialog-confirm"
								(click)="onRetry()" >{{loaderData().retryBtnText ?? 'Retry'}}</button>
			}
		</mat-dialog-actions>
	}
</div>

